// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlerOperationTriggerRequestParams
 */
export interface HandlerOperationTriggerRequestParams {
  /**
   *
   * @type {string}
   * @memberof HandlerOperationTriggerRequestParams
   */
  dbid?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationTriggerRequestParams
   */
  dbmsClusterId?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationTriggerRequestParams
   */
  orchestraName?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationTriggerRequestParams
   */
  raftMember?: string;
}

/**
 * Check if a given object implements the HandlerOperationTriggerRequestParams interface.
 */
export function instanceOfHandlerOperationTriggerRequestParams(
  value: object,
): value is HandlerOperationTriggerRequestParams {
  return true;
}

export function HandlerOperationTriggerRequestParamsFromJSON(
  json: any,
): HandlerOperationTriggerRequestParams {
  return HandlerOperationTriggerRequestParamsFromJSONTyped(json, false);
}

export function HandlerOperationTriggerRequestParamsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerOperationTriggerRequestParams {
  if (json == null) {
    return json;
  }
  return {
    dbid: json['dbid'] == null ? undefined : json['dbid'],
    dbmsClusterId:
      json['dbms_cluster_id'] == null ? undefined : json['dbms_cluster_id'],
    orchestraName:
      json['orchestra_name'] == null ? undefined : json['orchestra_name'],
    raftMember: json['raft_member'] == null ? undefined : json['raft_member'],
  };
}

export function HandlerOperationTriggerRequestParamsToJSON(
  json: any,
): HandlerOperationTriggerRequestParams {
  return HandlerOperationTriggerRequestParamsToJSONTyped(json, false);
}

export function HandlerOperationTriggerRequestParamsToJSONTyped(
  value?: HandlerOperationTriggerRequestParams | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    dbid: value['dbid'],
    dbms_cluster_id: value['dbmsClusterId'],
    orchestra_name: value['orchestraName'],
    raft_member: value['raftMember'],
  };
}
